import moment from "moment";

class Utilities {

  static WORKDAY_HOURS()  { return 8;}
  static AUTO_BALANCE_CHARGE_CODE_ID() {return 31;}

  /**
   * Round a number to two decimal places
   * @param {number} value - The value to round
   * @returns {number} The rounded value
   */
  static roundToTwoDecimals(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  /**
   * Check if a value is a valid number
   * @param {*} value - The value to check
   * @returns {boolean} True if the value is a number
   */
  static isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }

  /**
   * Format a date string consistently
   * @param {string|Date} date - The date to format
   * @param {string} format - The moment.js format string
   * @returns {string} The formatted date
   */
  static formatDate(date, format = 'YYYY-MM-DD') {
    return moment(date).format(format);
  }


  static formatNumber(value) {
    if (!value) return '';
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return formatter.format(value);
  };



  /**
   * Calculate the sum of hours from an array of time entries
   * @param {Array} entries - Array of time entries with hours property
   * @returns {number} The total hours
   */
  static calculateTotalHours(entries) {
    return entries.reduce((total, entry) => total + (entry.hours || 0), 0);
  }

  /**
   * Validate keyboard input for numeric fields
   * @param {Event} event - The keyboard event
   */
  static validateNumericInput(event) {
    let x = String.fromCharCode(event.charCode != null ? event.charCode : event.keyCode);
    let allowedValues = ['.', '1','2','3','4','5','6','7','8','9','0','-'];
    let cmdKeysAllowed = [8,46,37,39,9];
    let allowedWithShiftKey = [37,39];
    let allowedWithControlKey = ['v','c','x','a'];

    let allowedWithShift = event.shiftKey && (allowedWithShiftKey.indexOf(event.keyCode) > -1);
    let allowedWithControl = event.ctrlKey && (allowedWithControlKey.indexOf(x) > -1);
    let allowedStrings = allowedValues.indexOf(x) > -1;
    let allowedCommands = cmdKeysAllowed.indexOf(event.keyCode) > -1;

    let allowed = allowedWithShift || allowedWithControl || allowedStrings || allowedCommands;

    if(!allowed) {
      event.preventDefault();
    }
  }

  /**
   * Deep clone an object
   * @param {*} obj - The object to clone
   * @returns {*} The cloned object
   */
  static deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  static today() {
    return moment();
  }

}

export default Utilities;



// WEBPACK FOOTER //
// ./client/common/utilities.js